export const COORDINATES_CLOSE = '</coordinates>';

export const COORDINATES_OPEN = '<coordinates>';

export const DOCUMENT_CLOSE = '</Document>';

export const DOCUMENT_OPEN = '<Document>';

export const FOLDER_CLOSE = '</Folder>';

export const FOLDER_OPEN = '<Folder>';

export const KML_NAMESPACE = 'http://www.opengis.net/kml/2.2';

export const LINE_STRING_CLOSE = '</LineString>';

export const LINE_STRING_OPEN = '<LineString>';

export const NAME_CLOSE = '</name>';

export const NAME_OPEN = '<name>';

export const PLACEMARK_CLOSE = '</Placemark>';

export const PLACEMARK_OPEN = '<Placemark>';

export const XML_DECLARATION = '<?xml version="1.0" encoding="UTF-8"?>';
